import { render, staticRenderFns } from "./v-tag.vue?vue&type=template&id=588deb7b&scoped=true&"
import script from "./v-tag.vue?vue&type=script&lang=js&"
export * from "./v-tag.vue?vue&type=script&lang=js&"
import style0 from "./v-tag.vue?vue&type=style&index=0&id=588deb7b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588deb7b",
  null
  
)

export default component.exports